<template>
  <div>
    <h2 class="h2 text-light">Contact</h2>
    <h1 class="h1">Vul jouw gegevens in</h1>
    <div class="row-2">
      <div
        @click="setType('particulier')"
        class="card__option"
        :class="{ active: klant.type == 'particulier' }"
      >
        <h3 class="h2">
          <i class="fas fa-user"></i> Particulier
          <br />
          <span class="text-light h4"
            >Indien u dit als particulier wilt vervoeren</span
          >
        </h3>
      </div>
      <div
        @click="setType('zakelijk')"
        class="card__option"
        :class="{ active: klant.type == 'zakelijk' }"
      >
        <h3 class="h2">
          <i class="fas fa-user-tie"></i> Zakelijk
          <br />
          <span class="text-light h4"
            >Indien u dit zakelijk wilt vervoeren</span
          >
        </h3>
      </div>
    </div>
    <div class="card">
      <div class="row-2">
        <div
          v-if="isBussiness"
          class="form-group"
          :class="{
            'form-error':
              !$v.klant.bedrijfsnaam.required && $v.klant.bedrijfsnaam.$error
          }"
        >
          <label>Bedrijfsnaam</label>
          <input v-model="klant.bedrijfsnaam" type="text" />
        </div>
        <div
          v-if="isBussiness"
          class="form-group"
          :class="{
            'form-error': !$v.klant.kvk.required && $v.klant.kvk.$error
          }"
        >
          <label>KvK nummer</label>
          <input v-model="klant.kvk" type="text" />
        </div>
      </div>
      <div class="row-2">
        <div
          class="form-group"
          :class="{
            'form-error':
              !$v.klant.voornaam.required && $v.klant.voornaam.$error
          }"
        >
          <label>Voornaam</label>
          <input v-model="klant.voornaam" type="text" />
        </div>
        <div
          class="form-group"
          :class="{
            'form-error':
              !$v.klant.achternaam.required && $v.klant.achternaam.$error
          }"
        >
          <label>Achternaam</label>
          <input v-model="klant.achternaam" type="text" />
        </div>
      </div>
      <div class="row-2">
        <div
          class="form-group"
          :class="{
            'form-error': !$v.klant.email.required && $v.klant.email.$error
          }"
        >
          <label>E-mailadres</label>
          <input v-model="klant.email" type="text" />
        </div>
        <div
          class="form-group"
          :class="{
            'form-error':
              !$v.klant.telefoonnummer.required &&
              $v.klant.telefoonnummer.$error
          }"
        >
          <label>Telefoonnummer</label>
          <input v-model="klant.telefoonnummer" type="text" />
        </div>
      </div>
      <!-- <div class="form-group info">
        <p class>
          We gebruiken jouw contactgegevens alleen om te communiceren over het
          transport.
        </p>
      </div> -->
      <div class="error" v-if="$v.$error">
        Niet alle velden binnen deze stap zijn goed ingevuld.
      </div>
    </div>
    <button @click="nextStep" class="btn btn__filled w-100">Volgende</button>
    <button
      @click="goToPreviousRoute"
      class="btn btn__simple btn__left btn__backbt"
    >
      <i class="fas fa-chevron-left"></i> Terug
    </button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "PersonalData",
  computed: {
    ...mapFields(["klant"]),
    isBussiness() {
      return this.klant.type === "zakelijk";
    }
  },
  methods: {
    setType(type) {
      this.klant.type = type;
    },
    nextStep() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$root.goToNextRoute();
    }
  },
  validations() {
    return {
      klant: {
        type: {
          required
        },
        bedrijfsnaam: {
          requiredIf: requiredIf(() => {
            return this.isBussiness;
          })
        },
        kvk: {
          requiredIf: requiredIf(() => {
            return this.isBussiness;
          })
        },
        voornaam: {
          required
        },
        achternaam: {
          required
        },
        email: {
          required
        },
        telefoonnummer: {
          required
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 30px 40px;
  border: 1px solid var(--light-grey);
  margin-bottom: 10px;
}

.card__option {
  height: 90px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: 1px solid var(--light-grey);
  border-left-width: 5px;
  transition: border-color 300ms ease-in-out;

  @media only screen and (max-width: 890px) {
    margin-bottom: 20px;
  }

  .text-light {
    font-weight: 300;
    color: var(--orange);
    font-size: 16px;
  }

  .fas {
    font-size: 23px;
    margin-right: 8px;
    color: #333333;
  }
  &.active {
    border-left-width: 5px;
    border-left-color: var(--orange);
    border-color: var(--orange);
    box-shadow: 3px 3px 3px #e2e2e2;
  }

  .h2 {
    margin: 0;
    margin-left: 40px;
    line-height: 20px;
  }
}

.row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 10px;

  @media only screen and (max-width: 1200px) {
    grid-template-columns: 1fr !important;
  }
}

.btn.btn__filled.w-100 {
  margin-top: 20px;
}
</style>
